module.exports = __webpack_public_path__ + "static/WEDDING E&M-419-b276c2b78e4f6645bae648de25f2123d.jpg";